export const USER_NOTIFICATION_SETTING = {
  AT_MENTIONS: 'AT_MENTIONS',
  REPLIES_AND_AT_MENTIONS: 'REPLIES_AND_AT_MENTIONS',
  ALL: 'ALL'
};
export const GLOBAL_NOTIFICATION_EMAIL_SETTING = 'EMAIL';